<template>
  <!-- SECTION Machines-->
  <div id="machinesSection" class="row col-12 m-0 p-0 no-selection" style="height: calc(100vh - 10px);" v-if="!display.configurationView">
    <div class="row col-12 p-0 m-0 section-container justify-content-center">

      <!-- COMPONENT CommandCenter -->
      <div class="col-lg-12 col-md-8 col-12 m-0 p-1 overflow-show justify-content-center fixed-header">
        <div class="col-12 table-responsive bg-black rounded-top-5 m-0 p-0 shadow">
          <div class="row col-12 m-0 pt-2 pb-2 bg-black text-white">
            <div class="col-10 text-start">
              <ion-icon :name="'git-branch-outline'" class="tx-16 mb-1 me-1 align-bottom">
              </ion-icon>
              <span class="col-12 ps-3">
                {{ dictionary["Utillaje"][session.user.language] }}: {{ commandCenterLabel }}
              </span>
            </div>

            <div class="col-2 row justify-content-end">
              <button v-if="editingPermission" id="btnDisplayEditEraseModal"
                :title="dictionary['Editar centro de mando'][session.user.language]"
                style="width: 30px; max-height: 30px;"
                class="button-ok bg-transparent border-white mt-0 me-2 rounded shadow" @click="toggleConfigurationView">
                <span>
                  <span class="button-text text-white">
                    <ion-icon name="create-outline" class="pt-0 me-0 tx-18 hydrated"
                      :title="dictionary['Editar centro de mando'][session.user.language]"></ion-icon>
                    <!--<span class="text-dark mt-0">{{ dictionary["Añadir "+((this.$route.params.currentDisplay==="emplacements")?'emplazamiento':'centro de mando')][session.user.language]}}</span>-->
                  </span>
                </span>
              </button>
              <button id="btnDisplayEditEraseModal" :title="dictionary['Actualizar'][session.user.language]"
                style="width: 30px; max-height: 30px;"
                class="button-ok bg-transparent border-white mt-0 me-2 rounded shadow" @click="refreshView">
                <span>
                  <span class="button-text text-white">
                    <ion-icon name="refresh-outline" class="pt-0 me-0 tx-16 hydrated"
                      :title="dictionary['Actualizar'][session.user.language]"></ion-icon>
                    <!--<span class="text-dark mt-0">{{ dictionary["Añadir "+((this.$route.params.currentDisplay==="emplacements")?'emplazamiento':'centro de mando')][session.user.language]}}</span>-->
                  </span>
                </span>
              </button>
              <button id="btnDisplayEditEraseModal" :title="dictionary['Volver'][session.user.language]"
                style="width: 30px; max-height: 30px;"
                class="button-ok bg-transparent border-white mt-0 me-2 rounded shadow" @click="this.$router.go(-1)">
                <span>
                  <span class="button-text text-white">
                    <ion-icon name="return-down-back-outline" class="pt-0 me-0 tx-16 hydrated"
                      :title="dictionary['Volver'][session.user.language]"></ion-icon>
                    <!--<span class="text-dark mt-0">{{ dictionary["Añadir "+((this.$route.params.currentDisplay==="emplacements")?'emplazamiento':'centro de mando')][session.user.language]}}</span>-->
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>
        <div class="row col-12 m-0 p-0 bg-black justify-content-start rounded-bottom-5 shadow">

          <div class=" d-flex flex-column m-0 p-0 col-12 col-lg-12 col-xl-12 col-md-12 gap-1" style="height:  99vh;">

            <div class="row col-lg-12 col-xl-12 col-md-12 col-12 pt-1">
              <div class="col-12 bg-black">
                <div class="row" style="margin-top: 10px;">
                  <div class="col-2 scrollable-content" style="min-width: 250px;height: 100%;">
                    <div v-if="machineOrganigramLoading" class="text-center">
                      <div class="spinner-border" role="status">
                        <span class="sr-only"></span>
                      </div>
                    </div>

                    <div v-else class="tree-container no-selection scroll-hidden "
                      style="height: 100%; overflow-y: auto;">
                      <div v-for="machine in machineOrganigram" :key="machine.id" class="machine p-0 m-0 border-0">
                        <!-- Nivel 1: Máquina -->
                        <div class="machine-header rounded" @click="toggleMachine(machine.id)" style=" max-height: 30px;background-color: #061f5c;">
                          <span class="toggle-icon pe-2 me-3" style="width: 6px; color: white !important;"
                            v-html="machine.collapsed ? '<span class=\'material-symbols-rounded\'>add</span>' : '<span class=\'material-symbols-rounded\'>remove</span>'"></span>
                          <h6 class="machine-name6 text-white pt-2">{{ machine.name }}</h6>
                        </div>

                        <!-- Nivel 2: Dispositivos -->
                        <div class="devices-container m-0 p-0 ps-3" v-if="!machine.collapsed && machine.children">
                          <div v-for="device in machine.children" :key="device.id" class="device">
                            <div class="device-header" @click="toggleDevice(machine.id, device.id)" style=" max-height: 30px;background-color: #03103e;">
                              <span class="toggle-icon2 text-white"
                                v-html="device.collapsed ? '<span class=\'material-symbols-rounded\'>add</span>' : '<span class=\'material-symbols-rounded\'>remove</span>'"></span>
                              <img :src="getDeviceImage(device)" class="node-image small text-white" style="max-width: 6px;">
                              <h5 class=" c-pointer text-white" :data-id="device.id"> {{ device.name }}</h5>
                            </div>

                            <!-- Nivel 3: Subdispositivos -->
                            <div class="subdevices-container m-0 p-0 ps-2" v-if="!device.collapsed && device.children">
                              <div v-for="subdevice in device.children" :key="subdevice.id" class="subdevice">
                                <div class="subdevice-header1" style=" max-height: 40px;background-color: #061f5c;">
                                  <span class="toggle-icon3 text-white"
                                    @click="toggleSubdevice(machine.id, device.id, subdevice.id)"
                                    v-html="subdevice.collapsed ? '<span class=\'material-symbols-rounded\'>add</span>' : '<span class=\'material-symbols-rounded\'>remove</span>'"></span>
                                  <img :src="getSubdeviceImage(subdevice)" style="max-width: 30px; -webkit-filter: invert(100%); filter: invert(100%); display:none;" class="node-image xsmall" @click="toggleSubdevice(machine.id, device.id, subdevice.id)">
                                  <h6 class="btnTargetDevice c-pointer text-white pt-1 tx-14" :data-id="subdevice.id">{{ subdevice.name }}
                                  </h6>
                                  <span class="material-symbols-rounded btnTargetDevice1 eyeico text-white ps-2 pb-1" style="font-size: 14px !important;"
                                    :data-id="subdevice.id">Visibility</span>
                                </div>

                                <!-- Datos del subdispositivo -->
                                <div class="subdevice-data text-white" style="background-color: #03103e;" v-if="!subdevice.collapsed">
                                 
                                  <div v-for="(value, key) in subdevice.variables.analog" :key="key"
                                    class="variable-item">
                                    
                                    <p    v-if="!['est', 'Vibration Axis X', 'Vibration Axis Y', 'Vibration Axis Z' , 'Presencia'].includes(key) && value.isConfiguration !== 'true'"
                                    :key="key">
                                      <strong>{{ dictionary[key]?.[session.user.language] || key }}:</strong>
                                      <span>
                                        {{ value.value }} {{ value.unit }}
                                      </span>
                                    </p>
                                  </div>

                                  <div  v-for="(value, key) in subdevice.variables.digital"
                                              :key="'digital-' + key"
                                    class="variable-item">
                                    
                                    <p  v-if="!['Presencia'].includes(key) && value.isConfiguration !== 'true'">
                                      <strong>{{ dictionary[key]?.[session.user.language] || key }}:</strong>
                                      {{ console.log("value:",key) }}
                                      <span>
                                        {{ value.value === 'true' ? dictionary['true'][session.user.language] :
                                                dictionary['false'][session.user.language] }}
                                      </span>
                                    </p>
                                  </div>
                                 
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row col m-0 p-0 ms-3" style="min-width: 400px;">
                    <div class="row justify-content-around col-12 bg-lat1 p-0 pt-2 pb-2 pe-3 m-0 rounded-top-5">
                      <div class="col-3 pt-1">
                        <h6 class="mt-1 text-white">{{ dictionary["Gráficas"][session.user.language] }} {{
                        deviceData.label }}</h6>
                      </div>
                      <div class="col-2 pt-1">
                        <select v-model="targetVariableId" id="selectTargetDevice" data-live-search="true"
                          class="col-12 p-1 text-nowrap bg-white rounded" style="height: 31px; margin-top: -4px; max-width: 250px;" @change=changeChartDisplay()>
                          <option v-for="variable in historyVariables" :key="variable['variableId']"
                            :value="variable['variableId']" :selected="variable['variableId'] === targetVariableId"
                            class="text-dark">
                            {{ variable['label'][0].toUpperCase() + variable['label'].substring(1) }}
                          </option>
                        </select>
                      </div>
                      <div class="col-7 m-0 p-0">
                        <div class="d-flex m-0 p-0 align-items-center justify-content-between">
                          <!-- Input group -->
                          <div class="d-flex align-items-center">
                            <input v-model="startDateTimeInput" id="inputStartDate"
                              class=" form-control rounded text-nowrap bg-white text-dark me-2"
                              :type="(session.browser === 'firefox') ? 'date' : 'datetime-local'"
                              style="max-width: 140px; max-height: 30px; font-size:12px;">
                            <input v-model="endDateTimeInput" id="inputEndDate"
                              class=" form-control rounded text-nowrap bg-white text-dark"
                              :type="(session.browser === 'firefox') ? 'date' : 'datetime-local'"
                              style="max-width: 140px; max-height: 30px; font-size:12px;">
                            <ion-icon name="refresh-outline" class="tx-18 pe-0 pt-1 btn btnSizeChart text-white"
                              @click="changeChartDisplay()">
                            </ion-icon>
                          </div>

                          <!-- Icon group -->
                          <div class="d-flex align-items-start">
                            <ion-icon name="download-outline" class="tx-18 p-1 btn btnSizeChart text-white" @click="generateCSV()">
                            </ion-icon>
                            <ion-icon name="trash-outline" class="tx-18 pe-0 pt-1 btn btnSizeChart text-white"
                              @click="chartHistory = {}">
                            </ion-icon>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="bg-black rounded-5 p-0 m-0">
                      <VueEcharts :option="chart1Options" id="Chart1Canvas" class="col-12 w-100 ps-0 pe-0"
                        style="min-height: 44.25rem;">
                      </VueEcharts>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { VueEcharts } from 'vue3-echarts';
import echartsOptionsJson from '@/assets/json/echarts_options.json';
import "@ssthouse/vue3-tree-chart/dist/vue3-tree-chart.css";
import $ from 'jquery';

// Clomos
import api from '@/services/api';

export default {
  name: "UtillajesComp",
  components: { VueEcharts },
  props: {
    session: {
      type: Object,
      required: true,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    countries: {
      type: Object,
      required: true,
    },
    timeZones: {
      type: Object,
      requiered: true,
    },
    visibility: {
      type: Object,
      required: true,
    },
    currentCompany: {
      type: Object,
      required: true,
    },
    availableCompanies: {
      type: Object,
      required: true,
    },
    dataTableOptions: {
      type: Object,
      required: true,
    },
    typesByCompany: {
      type: Object,
      required: true,
    }
  },
  watch: {
    // Forma correcta de observar cambios en parámetros de ruta


    historyVariables: {
      immediate: true,
      async handler() {
        if (!this.targetVariableId && Object.entries(this.historyVariables)[0] != undefined) {
          this.targetVariableId = Object.entries(this.historyVariables)[0][0];
        }
      }
    }
  },
  data() {
    return {
      // GAUGE CHARTS
      gaugeChartOptions: JSON.parse(JSON.stringify(echartsOptionsJson))["gaugeChartOptions"],

      currentUtillajeIndex: 0,

      machineOrganigramLoading: false,
      targetEmplacementData: {},
      machineId: '',
      machineOrganigram: '',
      treeConfig: { nodeWidth: 240, nodeHeight: 130, levelHeight: 130 },
      devicesByCommandCenter: [],
      machinesByCommandCenter: [],
      display: {
        newDeviceModal: false,
        editDeviceModal: false,
        linkDeviceModal: false,
        deleteDeviceModal: false,
        newHistoricModal: false,
        editHistoricModal: false,
        editCommentsModal: false,
        configurationView: false,
      },
      linkAction: "link",
      targetDeviceId: '',
      selectedStatuses: [],
      lineChartOptions: JSON.parse(JSON.stringify(echartsOptionsJson))["lineChartOptions"],
      targetVariableId: '',
      deviceData: '',
      startDateTimeInput: api.parseDateTimeToString(new Date().setDate(new Date().getDate() - 1)),
      endDateTimeInput: api.parseDateTimeToString(new Date()),
      startDateTime: {
      },
      endDateTime: {
      },
      chartHistory: {
      },
      colors: ["#9e9e9e",
        "#4e79a7",
        "#f28d2b",
        "#e05759",
        "#76b7b2",
        "#59a14f",
        "#af7aa1",
        "#b1de89",
        "#595055",
        "#edc948",
        "#1c8356",
        "#ff9da7",
        "#8d9fca",
        "#2f451e"],
      checkboxTargetAxisLeft: true,
      checkboxTargetAxisRight: false,
      editingPermission: false,
      commandCenterLabel: ''
    }
  },
  emits: ["handleHasRol"],
  methods: {

    async organizeNode(node, levelPath, newMachineOrganigram) {
      let currentLevel = levelPath.split('.').map(Number);
      let target = newMachineOrganigram;

      for (let i = 0; i < currentLevel.length; i++) {
        const level = currentLevel[i];
        if (!target.children) target.children = [];
        if (!target.children[level]) target.children[level] = { children: [] };
        target = target.children[level];
      }

      Object.assign(target, {
        id: node.id,
        name: node.label,
        type: node.dclClass,
        variables: node.variables,
        collapsed: target.collapsed !== undefined ? target.collapsed : false
      });

      if (node.dclClass === "2") {
        let typeCategory = this.typesByCompany?.machineTypeList?.filter(type => type.id === node.dclTypeId);
        target.category = typeCategory && typeCategory.length > 0 ? typeCategory[0].label : "";
      } else if (node.dclClass === "3") {
        let typeCategory = this.typesByCompany?.deviceTypeList?.filter(type => type.id === node.dclTypeId);
        target.category = typeCategory && typeCategory.length > 0 ? typeCategory[0].label : "";
      }
    },

    sortChildrenRecursively(node) {
      if (node.children && node.children.length > 0) {
        node.children.sort((a, b) => a.name.localeCompare(b.name));
        node.children.forEach(child => this.sortChildrenRecursively(child));
      }
    },

    toggleMachine(machineId) {
      const machine = this.findNode(this.machineOrganigram, machineId);
      if (machine) {
        machine.collapsed = !machine.collapsed;
      }
    },

    toggleDevice(machineId, deviceId) {
      const machine = this.findNode(this.machineOrganigram, machineId);
      if (machine && machine.children) {
        const device = this.findNode(machine.children, deviceId);
        if (device) {
          device.collapsed = !device.collapsed;
        }
      }
    },

    toggleSubdevice(machineId, deviceId, subdeviceId) {
      const machine = this.findNode(this.machineOrganigram, machineId);
      if (machine && machine.children) {
        const device = this.findNode(machine.children, deviceId);
        if (device && device.children) {
          const subdevice = this.findNode(device.children, subdeviceId);
          if (subdevice) {
            subdevice.collapsed = !subdevice.collapsed;
          }
        }
      }
    },


    findNode(nodes, id) {
      for (let node of nodes) {
        if (node.id === id) return node;
        if (node.children) {
          const found = this.findNode(node.children, id);
          if (found) return found;
        }
      }
      return null;
    },

    getDeviceImage(device) {
      if (device.category.toUpperCase().includes('PMAK')) return require('@/assets/img/Pmak.png');
      if (device.category.toUpperCase().includes('PVICE')) return require('@/assets/img/utillaje.jpeg');
      if (device.category.toUpperCase().includes('PBLOCK')) return require('@/assets/img/utl.png');
      return require('@/assets/img/machine.png');
    },

    getSubdeviceImage(subdevice) {
      if (subdevice.category.toUpperCase().includes('MAK')) return require('@/assets/img/mak20.png');
      if (subdevice.category.toUpperCase().includes('BLOCK PRESION')) return require('@/assets/img/block-sc.png');
      if (subdevice.category.toUpperCase().includes('BLOCK')) return require('@/assets/img/block-sc.png');
      if (subdevice.category.toUpperCase().includes('MORDAZA')) return require('@/assets/img/arnold.png');
      return require('@/assets/img/machine.png');
    },


    // DISPLAY
    generateCSV() {
      const data = this.chartHistory;
      let csvContent = "activo,variable,valor,fecha\n";
      const formatearFecha = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hour = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;
      };

      Object.keys(data).forEach((key) => {
        const entries = data[key];
        Object.keys(entries).forEach((sensorName) => {
          const readings = entries[sensorName];
          const date = formatearFecha(new Date(readings[0]));
          csvContent += `"${this.deviceData.label}"${this.session.user.fieldSeparator}"${key}"${this.session.user.fieldSeparator}"${readings[1]}"${this.session.user.fieldSeparator}"${date}"\n`;
        });
      });
      const csvName = `${this.currentCompany.name}_data.csv`;
      this.downloadCSV(csvContent, csvName);
    },


    downloadCSV(csvContent, fileName) {
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async displayMachineOrganigram() {
      this.machineOrganigramLoading = true;
      let newMachineOrganigram = [];
      let nodesToOrganize = [];
      let processedNodes = new Set();
      let rootResponse = await api.getMachineData(this.machineId);
      let rootNode = api.parseMachineFromResponse(rootResponse);
      if (rootNode) this.commandCenterLabel = rootNode.label
      if (rootNode.dclClass === "2") {
        rootNode.nodeLevel = "0";
        nodesToOrganize.push(rootNode);
        let typeCategory = this.typesByCompany?.machineTypeList?.filter(type => type.id === rootNode.dclTypeId);
        rootNode.category = typeCategory && typeCategory.length > 0 ? typeCategory[0].category : "";
        this.machinesByCommandCenter.push(rootNode);
        const processNodeChildren = async (parentNode, levelPrefix) => {
          if (!parentNode.children) return;
          let index = 0;
          for (let childId of Object.keys(parentNode.children)) {
            let childResponse;
            let childNode;
            if (processedNodes.has(parentNode.children[childId].id)) {
              console.warn(`Nodo con ID ${parentNode.children[childId].id} ya fue procesado, evitando bucle infinito.`);
              continue;
            }
            if (parentNode.children[childId].claseDcl === "2") {
              childResponse = await api.getMachineData(childId);
              childNode = api.parseMachineFromResponse(childResponse);
            } else if (parentNode.children[childId].claseDcl === "3") {
              childResponse = await api.getDeviceData(childId);
              childNode = api.parseDeviceFromResponse(childResponse);
            } else {
              continue;
            }
            processedNodes.add(childNode.id);
            let currentLevelPath = `${levelPrefix}.${index}`;
            childNode.nodeLevel = currentLevelPath;
            nodesToOrganize.push(childNode);
            if (childNode.dclClass === "3") {
              let typeCategory = this.typesByCompany?.deviceTypeList?.filter(type => type.id === childNode.dclTypeId);
              childNode.category = typeCategory && typeCategory.length > 0 ? typeCategory[0].category : "";

              this.devicesByCommandCenter.push(childNode);
            } else if (childNode.dclClass === "2") {
              let typeCategory = this.typesByCompany?.machineTypeList?.filter(type => type.id === childNode.dclTypeId);
              childNode.category = typeCategory && typeCategory.length > 0 ? typeCategory[0].category : "";
              this.machinesByCommandCenter.push(childNode);
            }
            await processNodeChildren(childNode, currentLevelPath);
            index++;
          }
        };  
        await processNodeChildren(rootNode, "0");
      }
      for (let node of nodesToOrganize) {
        await this.organizeNode(node, node.nodeLevel, newMachineOrganigram);

      }
      this.sortChildrenRecursively(newMachineOrganigram)
      this.machineOrganigram = newMachineOrganigram.children;
      this.machineOrganigramLoading = false;
    },

    controlScale(id, command) {
      let target = this.$refs[("scaleTree" + id)][0];
      switch (command) {
        case 'bigger':
          target.zoomIn()
          break
        case 'smaller':
          target.zoomOut()
          break
        case 'restore':
          target.restoreScale()
          break
      }
    },
    returnBack() {
      const path = this.$route.path;
      const newPath = path.replace('/commandCenter/', '/commandCenters/').replace(/\/[^/]+$/, '');
      this.$router.replace({
        path: newPath
      });
    },
    async onDisplayElements() {
      this.devicesByCommandCenter = [];
      this.machinesByCommandCenter = [];

      await this.displayMachineOrganigram()
      this.displayDevicesDataTable();
    },
    onGoToDevice(event) {
      this.$router.push({ params: { currentDisplay: "device", targetEntity: event.target.getAttribute('data-id') } });
    },
    // BUTTONS
    setButtonFunctions() {
      setTimeout(() => {
        $(".btnTargetDevice").get().forEach(btn => {
          btn.addEventListener('click', this.onTargetDevice);
        });
        $(".btnTargetDevice1").get().forEach(btn => {
          btn.addEventListener('click', this.onTargetDevice1);
        });
        $(".btnTargetDevice2").get().forEach(btn => {
          btn.addEventListener('click', this.onTargetMAchine1);
        });
        $(".btnGoToDevice").get().forEach(btn => {
          btn.addEventListener('click', this.onGoToDevice);
        });
        $(".pdf-icon").get().forEach(btn => {
          btn.addEventListener('click', this.onPrint);
        });
      }, 300);
    },
    onCopyId(event) {
      navigator?.clipboard?.writeText(event.target.getAttribute('data-id'));
    },

    displayDevicesDataTable() {
      $("#devicesDataTable").DataTable().draw();
      this.setButtonFunctions();
      if ($(".dataTables_paginate").get()[0] != undefined) $(".dataTables_paginate").get()[0].addEventListener('click', this.setButtonFunctions);
      $(".sorting").get().forEach((btn) => { btn.addEventListener('click', this.setButtonFunctions) });
    },

    async displayChartsByDistributionGroup(value) {
      let match = false;
      for (const key in this.historyVariables) {
        if (Object.prototype.hasOwnProperty.call(this.historyVariables, key)) {
          const variable = this.historyVariables[key];
          if (variable.distributionGroup === value) {
            this.targetVariableId = variable.variableId;
            await this.getDeviceVariableHistory();
            match = true;
          }
        }
      }
      if (!match) {
        if (Object.entries(this.historyVariables)[0] != undefined) {
          this.targetVariableId = Object.entries(this.historyVariables)[0][0];
        }
      }
    },



    toggleFilter(status) {
      const index = this.selectedStatuses.indexOf(status);
      if (index > -1) {
        this.selectedStatuses.splice(index, 1);
      } else {
        this.selectedStatuses.push(status);
      }
      this.filterTablebyStatus();
    },
    changeDeviceChartDisplay() {
      this.chartHistory = {}
      this.displayChartsByDistributionGroup('1')
    },
    changeChartDisplay() {
      this.getDeviceVariableHistory()
    },

    isActive(status) {
      return this.selectedStatuses.includes(status);
    },
    onTargetTreeDevice(id) {
      this.targetDeviceId = id
      this.deviceData = this.devicesByCommandCenter.find(device => device.id === this.targetDeviceId)
      this.changeDeviceChartDisplay()
    },
    // TARGET 
    async onTargetDevice(event) {
      console.log('TARGET WHERE ID:');
      console.log(event.target.getAttribute('data-id'));
      this.targetDeviceId = event.target.getAttribute('data-id')
      this.deviceData = this.devicesByCommandCenter.find(device => device.id === this.targetDeviceId)
      this.changeDeviceChartDisplay()


    },
    async onTargetDevice1(event) {
      console.log('TARGET WHERE ID:');
      console.log(event.target.getAttribute('data-id'));
      this.targetDeviceId = event.target.getAttribute('data-id')
      if (this.$route.params.currentDisplay === 'commandCenter') {
        this.$router.push({ params: { currentModule: "electricalMonitoring", currentDisplay: "device", targetEntity: this.targetDeviceId } });
      }
    },
    async onTargetMAchine1(event) {
      console.log('TARGET WHERE ID:');
      console.log(event.target.getAttribute('data-id'));
      this.targetDeviceId = event.target.getAttribute('data-id')
      if (this.$route.params.currentDisplay === 'commandCenter') {
        this.$router.push({ params: { currentModule: "electricalMonitoring", currentDisplay: "commandCenter", targetEntity: this.targetDeviceId } });
      }
    },
    // SET 
    onEditDevice(event) {
      console.log('SHOW WHERE ID:');
      console.log(event.target.getAttribute('data-id'));
      this.targetDeviceId = event.target.getAttribute('data-id');

      this.toggleEditDeviceModal();
    },
    // LINK 
    onLinkDevice(event) {
      console.log('LINK WHERE ID:');
      console.log(event.target.getAttribute('data-id'));
      this.targetDeviceId = event.target.getAttribute('data-id')
      this.linkAction = "link"
      this.toggleLinkDeviceModal();
    },
    // UNLINK 
    onUnlinkDevice(event) {
      console.log('UNLINK WHERE ID:');
      console.log(event.target.getAttribute('data-id'));
      this.targetDeviceId = event.target.getAttribute('data-id')
      this.linkAction = "unlink"
      this.toggleLinkDeviceModal();
    },
    // DELETE
    async onDeleteDevice(event) {
      if (!this.display.deleteDeviceModal) {
        console.log('DELETE WHERE ID:');
        console.log(this.targetDeviceId);
        this.targetDeviceId = event.target.getAttribute('data-id');
      }
      else {
        let response = await api.deleteDevice(this.targetDeviceId);
        if (response["status-code"] === "200") {
          window.alert("El dispositivo ha sido eliminado satisfactoriamente.");
        }
        else {
          window.alert("Error al eliminar el dispositivo.");
        }
      }
      await this.toggleDeleteDeviceModal();
    },

    async getDeviceVariableHistory(callback) {
      if (!this.historyVariables[this.targetVariableId]) return
      let targetAxis = (this.checkboxTargetAxisRight) ? 'right' : 'left';
      let step = false;
      if (this.deviceData != {}) {
        let request = {
          id: this.deviceData.id,
          variableLabel: this.historyVariables[this.targetVariableId].label,
          variableType: this.historyVariables[this.targetVariableId].type,
          limit: 0,
          offset: 0,
          startDateTime: api.parseDateTimeToUTCString(this.startDateTimeInput),
          endDateTime: api.parseDateTimeToUTCString(this.endDateTimeInput)
        }
        let response = await api.getDeviceVariableHistory(request);
        // PARSE HISTORY RESPONSE
        let parsedResponse = api.parseVariableDataFromHistoryResponse(response);
        let rawHistory = parsedResponse.history
        this.chartHistory[this.historyVariables[this.targetVariableId].label] = [];
        for (let i in rawHistory) {
          this.chartHistory[this.historyVariables[this.targetVariableId].label][i] = [
            // DATE
            this.$dayjs(new Date(rawHistory[i][0])).utc("z").local().tz(this.session.user.dateTimeZone).$d,
            // VALUE
            new Number(rawHistory[i][1]).toFixed(this.fractionalLength),
            // POSITION
            targetAxis,
            // STEP
            step,
            parsedResponse.unit
          ]
        }
        // SET DATA BOUNDRIES
        this.startDateTime = this.startDateTimeInput;
        this.endDateTime = this.endDateTimeInput;
        // SWITCH AXIS TARGET
        this.checkboxTargetAxisRight = !this.checkboxTargetAxisRight;
        this.checkboxTargetAxisLeft = !this.checkboxTargetAxisRight;
        if (callback && typeof callback === "function") callback(this.availableDevices)
      }
    },
    checkEditingRoleCallback(hasPermission) {
      this.editingPermission = hasPermission;
    },
    async refreshView() {
      if (this.$route.path.includes('commandCenter')) {
        const path = this.$route.path;
        const commandCenterId = path.split('commandCenter/')[1];
        if (commandCenterId) {
          this.machineId = commandCenterId;
          this.devicesByCommandCenter = [];
          this.machinesByCommandCenter = [];
          await this.displayMachineOrganigram()
          if (this.devicesByCommandCenter.length > 0) {
            this.deviceData = this.devicesByCommandCenter[0]
            this.targetDeviceId = this.devicesByCommandCenter[0].id
            await this.displayChartsByDistributionGroup('1')
          }
          this.displayDevicesDataTable()
        }
      }
    }

  },
  computed: {

    statusGaugeChartOptions() {

      let statusGaugeChartOptions = {};
      let rawDeviceData = JSON.parse(JSON.stringify(this.deviceData));
      if (rawDeviceData.variables === undefined) return statusGaugeChartOptions;
      for (let i in rawDeviceData.variables.analog) {
        if (rawDeviceData.variables.analog[i].isConfiguration === 'false') {
          statusGaugeChartOptions[i] = JSON.parse(JSON.stringify(this.gaugeChartOptions));
          statusGaugeChartOptions[i].series[0].detail.formatter = "{value} " + rawDeviceData.variables.analog[i].unit;
          if (rawDeviceData.variables.analog[i].unit === "%") {
            statusGaugeChartOptions[i].series[0].max = 100;
            statusGaugeChartOptions[i].series[0].min = 0;
          }
          else {
            statusGaugeChartOptions[i].series[0].max = Number(rawDeviceData.variables.analog[i].max);
            statusGaugeChartOptions[i].series[0].min = Number(rawDeviceData.variables.analog[i].min);
          }
          statusGaugeChartOptions[i].series[0].data[0] = {
            name: rawDeviceData.variables.analog[i].label,
            value: Number(rawDeviceData.variables.analog[i].value).toFixed(this.fractionalLength),
            saveHistory: rawDeviceData.variables.analog[i].saveHistory
          };
          statusGaugeChartOptions[i].valueDateTime = rawDeviceData.variables.analog[i].valueDateTime;
        }
      }
      for (let i in rawDeviceData.variables.digital) {
        if (rawDeviceData.variables.digital[i].isConfiguration === 'false') {
          statusGaugeChartOptions[i] = JSON.parse(JSON.stringify(this.gaugeChartOptions));
          statusGaugeChartOptions[i].series[0].detail.formatter = "{value} " + rawDeviceData.variables.digital[i].unit;

          statusGaugeChartOptions[i].series[0].max = Number(rawDeviceData.variables.digital[i].max);
          statusGaugeChartOptions[i].series[0].min = Number(rawDeviceData.variables.digital[i].min);
          statusGaugeChartOptions[i].series[0].data[0] = {
            name: rawDeviceData.variables.digital[i].label,
            value: rawDeviceData.variables.digital[i].value,
            type: 'digital',
            saveHistory: rawDeviceData.variables.digital[i].saveHistory
          };
          statusGaugeChartOptions[i].valueDateTime = rawDeviceData.variables.digital[i].valueDateTime;
        }
      }
      if (rawDeviceData.variables.dynamic?.Posicion) {
        const value = api.parseStringToGeoJSON(rawDeviceData.variables.dynamic.Posicion.value)
        const [lat, lon] = value.geometry.coordinates;
        const formattedCoordinates = `${lat.toFixed(2)}/${lon.toFixed(2)}`;
        statusGaugeChartOptions["Posicion"] = JSON.parse(JSON.stringify(this.gaugeChartOptions));
        statusGaugeChartOptions["Posicion"].series[0].data[0] = {
          name: rawDeviceData.variables.dynamic.Posicion.label,
          value: formattedCoordinates,
          saveHistory: rawDeviceData.variables.dynamic.Posicion.saveHistory

        };
        statusGaugeChartOptions["Posicion"].valueDateTime = rawDeviceData.variables.dynamic.Posicion.valueDateTime;
      }
      return statusGaugeChartOptions;

    },

    currentUtillaje() {
      return this.utillajes[this.currentUtillajeIndex];
    },
    filteredMachines() {
      return this.machines.filter(machine =>
        machine.name.includes(this.currentUtillaje.replace("Utillaje", "").trim())
      );
    },


    fractionalLength() {
      return (localStorage.getItem("ClomosFractionalLength") != undefined) ? localStorage.getItem("ClomosFractionalLength") : 2;
    },
    historyVariables() {
      let historyVariables = {};
      for (let variableType in this.deviceData.variables)
        for (let variable in this.deviceData.variables[variableType])
          if (this.deviceData.variables[variableType][variable].saveHistory === 'true' && (variableType === 'analog' || variableType === 'digital')) {
            historyVariables[this.deviceData.variables[variableType][variable].variableId] = this.deviceData.variables[variableType][variable];
          }
      return historyVariables;
    },

    chart1Options() {
      let chart1Options;
      chart1Options = JSON.parse(JSON.stringify(this.lineChartOptions));
      if (this.targetDeviceId == "") return chart1Options;
      chart1Options.axisPointer = {
        label: {
          formatter: ((dataTarget) => {
            let d = new Date(dataTarget.value);
            switch (this.session.user.dateTimeFormat) {
              case "DD/MM/YYYY":
                return String(d.getDate()).padStart(2, "0") + "/" + String((d.getMonth() + 1)).padStart(2, "0") + "/" + String(d.getFullYear()) + " \n " + String(d.getHours()).padStart(2, "0") + ":" + String(d.getMinutes()).padStart(2, "0");
              case "MM/DD/YYYY":
                return String((d.getMonth() + 1)).padStart(2, "0") + "/" + String(d.getDate()).padStart(2, "0") + "/" + String(d.getFullYear()) + " \n " + String(d.getHours()).padStart(2, "0") + ":" + String(d.getMinutes()).padStart(2, "0");
              default:
                return String((d.getMonth() + 1)).padStart(2, "0") + "/" + String(d.getDate()).padStart(2, "0") + "/" + String(d.getFullYear()) + " \n " + String(d.getHours()).padStart(2, "0") + ":" + String(d.getMinutes()).padStart(2, "0");
            }
          })
        }
      }
      chart1Options.xAxis = {
        min: new Date(this.startDateTime).getTime(),
        max: new Date(this.endDateTime).getTime(),
        axisLabel: {
          formatter: ((value) => {
            let d = new Date(value);
            switch (this.session.user.dateTimeFormat) {
              case "DD/MM/YYYY":
                return String(d.getDate()).padStart(2, "0") + "/" + String((d.getMonth() + 1)).padStart(2, "0") + "/" + String(d.getFullYear()) + " \n " + String(d.getHours()).padStart(2, "0") + ":" + String(d.getMinutes()).padStart(2, "0");
              case "MM/DD/YYYY":
                return String((d.getMonth() + 1)).padStart(2, "0") + "/" + String(d.getDate()).padStart(2, "0") + "/" + String(d.getFullYear()) + " \n " + String(d.getHours()).padStart(2, "0") + ":" + String(d.getMinutes()).padStart(2, "0");
              default:
                return String((d.getMonth() + 1)).padStart(2, "0") + "/" + String(d.getDate()).padStart(2, "0") + "/" + String(d.getFullYear()) + " \n " + String(d.getHours()).padStart(2, "0") + ":" + String(d.getMinutes()).padStart(2, "0");
            }
          }),
          textStyle: {
            fontSize: 9
          },
          axisLineShow: true
        }
      }
      chart1Options.tooltip = {
        trigger: "axis",
        axisPointer: {
          snap: true,
          lineStyle: {
            color: "#242e47",
            width: 2
          }
        },
        formatter: (params) => {
          let result = params[0].axisValueLabel + "<br/>";

          params.forEach(item => {
            let formattedValue = new Intl.NumberFormat(this.session.user.language === "en" ? 'en-IN' : 'es-ES', {
              maximumFractionDigits: this.fractionalLength
            }).format(Number(item.data[1]));

            result += `${item.marker} <strong>${item.seriesName}:</strong> ${formattedValue} ${(item.data[4] ?? '')} <br/>`;
          });

          return result;
        }
      };
      let i = 0;
      for (let variable in this.chartHistory) {
        chart1Options.yAxis[i] = {
          type: "value",
          axisLine: {
            lineStyle: {
              color: this.colors[i]
            }
          },
          name: variable.substring(0, 3).toUpperCase(),
          nameTextStyle: {
            fontSize: 10
          },
          axisLabel: {
            fontSize: 9,
            formatter: (value) => {
              return new Intl.NumberFormat(this.session.user.language === "en" ? 'en-IN' : 'es-ES', {
                maximumFractionDigits: Number(this.fractionalLength)
              }).format(value) + ` ${(this.chartHistory[variable][i] != undefined)
                ? this.chartHistory[variable][i][4]
                : ''}`;
            }
          },
          offset: Math.floor(i / 2) * 35,
          position: (this.chartHistory[variable][i] != undefined)
            ? this.chartHistory[variable][i][2]
            : (i % 2 === 0)
              ? "left"
              : "right"
        }
        chart1Options.legend.data[i] = variable;
        chart1Options.series[i] = {
          data: this.chartHistory[variable],
          name: variable,
          yAxisIndex: i,
          type: "line",
          symbol: "emptyDiamond",
          symbolSize: 6,
          color: this.colors[i],
          smooth: false,
          step: (this.chartHistory[variable] != undefined) ? this.chartHistory[variable] : false,
          areaStyle: {
            color: this.colors[i],
            opacity: 0.03
          },
        }
        i += 1;
      }
      return chart1Options;
    },


  },
  async created() {
    if (this.$route.path.includes('commandCenter')) {
      const path = this.$route.path;
      const commandCenterId = path.split('commandCenter/')[1];
      if (commandCenterId) {
        this.machineId = commandCenterId;
        await this.displayMachineOrganigram()
        if (this.devicesByCommandCenter.length > 0) {
          this.deviceData = this.devicesByCommandCenter[0]
          this.targetDeviceId = this.devicesByCommandCenter[0].id
          await this.displayChartsByDistributionGroup('1')
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.refreshView()
    });


  },
}
</script>

<style>
.btnTargetDevice1:hover {
  color: var(--main-dark) !important;
}

.scroll-hidden {
  overflow-y: auto;
  /* Permite scroll vertical */
  scrollbar-width: none;
  /* Oculta barra en Firefox */
  -ms-overflow-style: none;
  /* Oculta barra en IE/Edge */
}

/* Oculta barra en Chrome/Safari/Opera */
.scroll-hidden::-webkit-scrollbar {
  display: none;
}

/* Estilos clave para el scroll */
.fixed-header {
  position: sticky;
  top: 0;
  z-index: 100;
}

/* Asegura que el contenedor principal ocupe el espacio restante */
.scrollable-content {
  height: calc(100vh - 180px);
  /* Ajusta según el tamaño de tu header */
  overflow: hidden;
  /* Oculta el overflow del contenedor padre */
}

.machine-name6 {
  font-weight: bold;
  margin-left: 1%;
}


/* Efecto de transición para cambio de valores */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}



.node-image xsmall {
  width: 20px;
}

.machine {
  margin-bottom: 15px;
  border-left: 3px solid #0090f0;
  padding-left: 10px;
}

.machine-header {
  font-weight: bold;
  font-size: 18px;
  cursor: pointer;
  padding: 8px;
  background-color: #061f5c;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.node-name,
.data-text {
  pointer-events: none;
  /* Previene la selección indirecta */
}

.devices-container {
  position: relative;
  margin-left: 25px;
  padding-left: 15px;
}

.devices-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  /*border-left: 2px solid #4caf50;
   Color verde para nivel 2 */
}

.device {
  position: relative;
  padding-top: 5px;
}

.device::before {
  content: '';
  position: absolute;
  top: 20px;
  /* Ajusta según altura de tu header */
  left: -15px;
  width: 15px;
  border-top: 2px solid #4caf50;
  /* Mismo verde para conexión horizontal */
}



.device-data {
  margin-left: 20px;
  margin-top: 5px;
  padding: 8px;
  background-color: #e9ecef;
  border-radius: 4px;
  font-size: 14px;
}

.device-data p {
  margin: 8px 0;
  display: flex;
  align-items: center;
  font-size: medium;
  gap: 6px;
}

.toggle-icon {
  font-weight: bold;
  font-size: 40px;
  text-align: center;
}

.toggle-icon2 {
  display: flex;
  font-weight: bold;
  font-size: 10px;
  text-align: center;
}

/* Estilos para imágenes */
.node-image {
  margin-right: -5%;
  margin-left: -5%;
  width: 150px;
  height: 100px;
  object-fit: contain;
}

.node-image.small {
  width: 80px;
  height: 50px;
  margin-left: 3px;
}


/* Efectos hover */
.machine-header:hover,
.device-header:hover {
  background-color: #000;
}

/* Mejoras visuales */
.machine-header {
  transition: all 0.2s ease;
}

.device-header {
  transition: all 0.2s ease;
}

.device-data {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Nuevos estilos para subdispositivos */
/* Líneas para subdispositivos (tercer nivel) */
.subdevices-container {
  position: relative;
  margin-left: 25px;
  padding-left: 15px;
}

.subdevices-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-left: 1px solid #fcfcfc;
 /* border-left: 2px solid #ff9800;
   Color naranja para nivel 3 */
}

.subdevice {
  position: relative;
  padding-top: 5px;
}

.subdevice::before {
  content: '';
  position: absolute;
  top: 18px;
  /* Ajusta según altura de tu header */
  left: -5px;
  width: 0px;
  border-top: 2px solid #ff9800;
  /* Mismo naranja para conexión horizontal */
}


.subdevice-header1 {
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  padding: 5px 8px;
  background-color: #f8f8f8;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}

.subdevice-header:hover {
  background-color: #ececec;
}

.subdevice-data {
  margin-left: 25px;
  margin-top: 5px;
  padding: 6px 8px;
  background-color: #e9ecef;
  border-radius: 4px;
  font-size: 13px;
}

.subdevice-data p {
  margin: 6px 0;
  display: flex;
  font-size: small;
  align-items: center;
  gap: 5px;
}

.toggle-icon3 {
  font-weight: bold;
  width: 20px;
  text-align: center;
  font-size: 20px;
}

.node-image.xsmall {
  width: 60px;
  height: 50px;
  margin-right: 1%;
  margin-left: 3px;
}

.data-icon {
  width: 14px;
  height: 14px;
  margin-right: 5px;
}


/* Mejoras visuales para la jerarquía */
.devices-container {
  border-left-color: #a0a0a0;
}

.subdevices-container {
  border-left-color: #c0c0c0;
}

.machine-header {
  background-color: #e3f2fd;
}

.device-header {
  background-color: #03103e;
}

.subdevice-header1 {
  background-color: #fcf2e5;
}

.btn-custom-primary {
  font-size: 12;
  border: 2px solid #3498db;
  border-left: 10px solid #3498db;
  color: black;
  background-color: #fff;
  transition: border-color 0.3s ease, color 0.3s ease, background-color 0.3s ease;
}

.btn-custom-secondary {
  border: 2px solid #2ecc71;
  border-left: 10px solid #2ecc71;
  color: black;
  background-color: #fff;
  transition: border-color 0.3s ease, color 0.3s ease, background-color 0.3s ease;
}

.btn-custom-success {
  border: 2px solid #e67e22;
  border-left: 10px solid #e67e22;
  color: black;
  background-color: #fff;
  transition: border-color 0.3s ease, color 0.3s ease, background-color 0.3s ease;
}

.btn-custom-danger {
  border: 2px solid #e74c3c;
  border-left: 10px solid #e74c3c;
  color: black;
  background-color: #fff;
  transition: border-color 0.3s ease, color 0.3s ease, background-color 0.3s ease;
}

.btn-custom-warning {
  border: 2px solid #f39c12;
  border-left: 10px solid #f39c12;
  color: black;
  background-color: #fff;
  transition: border-color 0.3s ease, color 0.3s ease, background-color 0.3s ease;
}


.btn-custom-primary:hover {
  font-size: 12;
  border-color: #2980b9;
  background-color: #eaf0f8;
}

.btn-custom-secondary:hover {
  border-color: #27ae60;

  background-color: #eaf6e7;
}

.btn-custom-success:hover {
  border-color: #d35400;
  background-color: #f8eae2;
}

.btn-custom-danger:hover {
  border-color: #c0392b;
  background-color: #f8d7da;
}

/* */
.btn-primary-active {
  border-color: #2980b9 !important;
  background-color: #eaf0f8 !important;
  box-shadow: inset 0 0 10px #2980b9;

  font-weight: bold;
  position: relative;
}

.btn-secondary-active {
  border-color: #27ae60 !important;
  background-color: #eaf6e7 !important;
  box-shadow: inset 0 0 10px #27ae60;

  font-weight: bold;
  position: relative;
}

.btn-success-active {
  border-color: #d35400 !important;
  background-color: #f8eae2 !important;
  box-shadow: inset 0 0 10px #d35400;

  font-weight: bold;
  position: relative;
}

.btn-danger-active {
  border-color: #c0392b !important;
  background-color: #f8d7da !important;
  box-shadow: inset 0 0 10px #c0392b;

  font-weight: bold;
  position: relative;
}

.btn-warning-active {
  border-color: #e67e22 !important;
  background-color: #fff3e0 !important;
  box-shadow: inset 0 0 10px #e67e22;

  font-weight: bold;
  position: relative;
}

.btn-primary-active::after,
.btn-secondary-active::after,
.btn-success-active::after,
.btn-danger-active::after,
.btn-warning-active::after {
  content: '✓';
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.material-symbols-rounded {
  font-size: 14px !important;
}
</style>